module.exports = __webpack_public_path__ + "img/temple.1ad20ae7.png";